import { render } from "./ExamPage.vue?vue&type=template&id=3c580820&scoped=true"
import script from "./ExamPage.vue?vue&type=script&lang=js"
export * from "./ExamPage.vue?vue&type=script&lang=js"

import "./ExamPage.vue?vue&type=style&index=0&id=3c580820&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c580820"]])

export default __exports__